<template>
    <page :loading="loading">
        <div slot="header" class="flex-row">
        	<div class="flex-item page_header">
        		<el-form size="small" :inline="true">
        			<el-form-item label="保险名称">
        				<el-input v-model="table.search.keyword" placeholder="请输入名称" clearable>
        				</el-input>
        			</el-form-item>
					<el-form-item label="所属分组">
						<el-select v-model="table.search.group_ids" multiple placeholder="请选择" clearable>
						    <el-option v-for="(item, index) in groupList" :key="index" :label="item.name" :value="item.id">
						    </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属分类">
						<el-cascader v-model="table.search.category_ids_array" :options="categoryList" :props="cascaderProps" clearable></el-cascader>
					</el-form-item>
        			<el-form-item label="保险状态">
        				<el-select clearable v-model="table.search.status" placeholder="请选择" clearable>
        				    <el-option :value="1" label="上架"></el-option>
        				    <el-option :value="0" label="下架"></el-option>
        				</el-select>
        			</el-form-item>
        			<el-form-item>
        				<el-button size="small" type="primary" plain @click="LoadDatas(1,20)">
        					查询
        				</el-button>
        				<el-button size="small" type="info" plain @click="reset">
        					重置
        				</el-button>
        				<el-button size="small" type="success" plain @click="exportExcel" :loading="exportLoading">
        					导出Excel
        				</el-button>
        			</el-form-item>
        		</el-form>
        		<el-form size="small" :inline="true">
        			<el-form-item>
        				<el-button @click="info = {}, showDrawer = true" type="primary" plain>添加保险</el-button>
        			</el-form-item>
        		</el-form>
        	</div>
        </div>

        <page-table @sortChange="sortChange" :datas="table.data" :page="table.search._page" :size="table.search._size" :total="table._count" @change="LoadDatas">
            <el-table-column prop="id" 	  label="id"   align="center" fixed="left"  width="120" sortable="custom"/>
			<el-table-column prop="main_image" label="保险封面图" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-image fit="cover" :src="$img(scope.row.main_image)"  :preview-src-list="[$img(scope.row.main_image)]"/>
				</template>
			</el-table-column>
            <el-table-column prop='name'                           label='保险名称' align='center' />
            <el-table-column prop='price'                          label='销售起价' align='center' sortable="custom"/>
            <el-table-column prop='sales'                          label='销量' align='center' sortable="custom"/>
            <el-table-column prop='sort'                           label='排序' align='center' sortable="custom"/>
            <el-table-column prop='status'                         label='状态' align='center'>
                <template slot-scope="scope">
                	<el-tag v-if="scope.row.status">上架</el-tag>
                	<el-tag v-else type="danger">下架</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop='created_at'                     label='创建时间' align='center' />
            <el-table-column prop='updated_at'                     label='更新时间' align='center' />
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button @click="info = scope.row, showDrawer = true" type="text" size="small">详情</el-button>
                    <el-button @click="ActionDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </page-table>
		
		<el-drawer :modal="false" v-if="showDrawer" title="保险信息" size="100%" :visible.sync="showDrawer">
			<info  @save="save()" @cancel="showDrawer = false" :id="info.id" :groupList="groupList" :categoryList="categoryList"/>
		</el-drawer>
    </page>
</template>
<script>
import info from '../component/info.vue';
export default {
	components: {
		info
	},
    data(){
        return {
            loading:false,
			exportLoading: false, // 导出加载状态
            table:{
                data: [],
                form: {},
                search: {
                    _page: 1,
                    _size: 20,
					_order: '',
					_isreverse: 1,// 是否倒序 0否 1是（默认1）
                },
				_count:0,
            },
			showDrawer: false,
			info: {},
			groupList: [],
			cascaderProps: {
				multiple: true,
				value: 'id',
				label: 'name',
			},
			categoryList: [],
        }
    },
    mounted() {
        this.LoadDatas();
		this.getGroupList();
		this.getCategoryList();
    },
    methods: {
		async exportExcel() {
			this.exportLoading = true;
			try {
				// 构建导出参数
				const exportParams = this.$buildExportParams(this.table.search);
		
				// 调用导出
				await this.$export('goodsExport', exportParams, '产品导出');
			} catch (error) {
				this.$message.warning(error);
			} finally {
				this.exportLoading = false;
			}
		},
		getGroupList(){
			this.$get('app-goods-group',{_page: 0}).then(res=>{
			    this.groupList = res.data;
			}).catch(err=>{
			    this.$warning(err);
			});
		},
		getCategoryList(){
			this.$get('treeCategoryList').then(res=>{
			    this.categoryList = res.data;
			}).catch(err=>{
			    this.$warning(err);
			});
		},
		save(){
			this.showDrawer = false;
			this.info = {};
			this.reset();
		},
		reset(){
			this.table.search = {
				_page: 1,
				_size: 20,
				_order: '',
				_isreverse: 1
			};
			this.LoadDatas();
		},
		sortChange(e){
			var isreverse =  1;
			if( e.order == null ){
				this.reset();
			}else if( e.order == 'descending' ){
				var isreverse = 1;
			}else if ( e.order == 'ascending' ){
				var isreverse = 0;
			}
			this.table.search = {
				_page: 1,
				_size: 20,
				_order: e.prop,
				_isreverse: isreverse
			};
			this.LoadDatas();
		},
        /**
         * 获取数据列表
         * @param page 分页-当前页
         * @param size 分页-每页数量
         * **/
        LoadDatas(page,size){
            page && (this.table.search._page = page),size && (this.table.search._size = size),this.loading = true;
            this.$get('app-goods',this.table.search).then(res=>
            {
                this.table.data = res.data , this.table._count = res.extra.pageInfo.count , this.loading = false;
            }).catch(err=>
            {
                this.$notify.error({message: err || '网络请求错误'}),this.loading = false;
            });
        },
        /**
         * 删除
         * @param item 要删除的数据
         * **/
        ActionDel(item){
            if( item.id ){
                this.loading = true;
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                    this.$del('app-goods/'+item.id).then(res=>{
                        this.loading = false , this.LoadDatas() , this.$notify({message: res.msg || '操作成功'});
                    }).catch(err=>{
                        this.loading = false , this.$notify.error({message:err||'删除失败'});
                    })
                }).catch(()=>{
                    this.loading = false;
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
	.page_header {
		margin:10px 10px 0;
		position: absolute;
		z-index: 100;
	}
	
	.el-drawer__wrapper {
	  z-index: 1001 !important;
	}
	
	.el-image {
		width: 80px; 
		height: 120px;
		border-radius: 5px;
	}
</style>